import constants from "../constants/constants";
import roleConstants from "../constants/roles";

const {
  PAGE_ROUTES: { DAILY_BOOKING_ROUTE, VERIFY_BOOKING_ROUTE }
} = constants;

const { AGENCY_USER, FINANCE_USER, AGENCY_ADMIN, CLIENT_USER } = roleConstants;

const getDefaultRoute = role => {
  switch (role) {
    case AGENCY_USER:
    case AGENCY_ADMIN:
    case CLIENT_USER:
      return DAILY_BOOKING_ROUTE;
    case FINANCE_USER:
      return VERIFY_BOOKING_ROUTE;
    default:
      return DAILY_BOOKING_ROUTE;
  }
};

export default getDefaultRoute;
